module.exports = __webpack_public_path__ + "img/blog(right-sidebar).7e0836a6.jpg";